import { useContext } from 'react';
import FeedbackQuestionsContext from '../store/FeedbackQuestionsState';

/** @typedef {import("@amzn/coral_com-amazon-trans-feedback-tcfa-model-v-1").Questionnaire} Questionnaire */

/**
 * Use questions hook
 *
 * @returns {{ questions: Questionnaire }}
 */
const useQuestions = () => {
  const { questions } = useContext(FeedbackQuestionsContext);

  return {
    questions,
  };
};

export default useQuestions;
